module.exports = __webpack_public_path__ + "static/media/5.15983b31.jpg";